<template>
  <div id="app">
    <router-view/>
    <!--<Loader :loading="$loading.show" :overlayClassName="$loading.class"></Loader>-->
    <Spinner v-show="$loading.isShow"
             :class="{'preloader-overlay--white': $loading.isWhite}"
    />
  </div>
</template>

<script>
import {AUTHORIZATION} from './constants/constants'
import Spinner from './components/Spinner'
export default {
  name: 'App',
  async created () {
    // this.$loading.class = 'loader-overlay--white'
    // this.$loading.show = true
    await this.$store.dispatch('fetch', localStorage.getItem(AUTHORIZATION), {root: true})
      .then(data => {
        if (data && data.status !== 200) {
          this.$router.push('/login')
        }
        // this.$loading.class = ''
        //
        // this.$loading.show = false
      })
  },
  components: {
    Spinner
  }
}
</script>

<style lang="scss">
  // CoreUI Icons Set
  @import '../node_modules/@coreui/icons/css/coreui-icons.min.css';
  /* Import Simple Line Icons Set */
  $simple-line-font-path: '../node_modules/simple-line-icons/fonts/';
  @import '../node_modules/simple-line-icons/scss/simple-line-icons.scss';
  /* Import Font Awesome Icons Set */
  $fa-font-path: '../node_modules/font-awesome/fonts/';
  @import '../node_modules/font-awesome/scss/font-awesome.scss';
  /* Import Bootstrap Vue Styles */
  @import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css';
  // Import Main styles for this application
  @import 'assets/scss/style';
  @import 'assets/css/custom.css';
</style>



// WEBPACK FOOTER //
// src/App.vue